import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.post.detail');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-portal-post-detail',
template: templateSource || '',
    styles: [``],
})
export class PortalPostDetailComponent implements OnInit, OnDestroy {
    public id: string = '';
    public tab: string = 'view';
    public data: any = null;
    public saving: boolean = false;
    public comments: any[] = [];
    public commentText = '';
    public commentBusy = false;
    public commentError = '';

    public tabs: any[] = [];

    private basePath: string = '/posts';
    private routerSub: any;
    private langSub: Subscription;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router,@Inject( TranslateService)  private translate: TranslateService) {
        this.id = WizRoute.segment.id;
        this.tab = WizRoute.segment.tab || 'view';
        this.buildTabs();
    }

    public async ngOnInit() {
        await this.service.init();

        this.langSub = this.translate.onLangChange.subscribe(() => {
            this.buildTabs();
            this.service.render();
        });

        // 탭 전환 감지: NavigationEnd 구독
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id;
                const newTab = WizRoute.segment.tab || 'view';

                if (newId && newId !== this.id) {
                    this.id = newId;
                    this.tab = newTab;
                    await this.load();
                } else if (newTab !== this.tab) {
                    this.tab = newTab;
                    await this.service.render();
                }
            }
        });

        // tab 없이 접근 시 기본 탭으로 리다이렉트
        if (!WizRoute.segment.tab) {
            this.service.href(`${this.basePath}/${this.id}/view`);
            return;
        }

        await this.load();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.langSub) this.langSub.unsubscribe();
    }

    private buildTabs() {
        this.tabs = [
            { key: 'view', label: this.translate.instant('portal.post.tab.view'), icon: '📄' },
            { key: 'edit', label: this.translate.instant('common.edit'), icon: '✏️' },
            { key: 'settings', label: this.translate.instant('menu.settings'), icon: '⚙️' },
        ];
    }

    public isNewPost() {
        return this.id === 'new';
    }

    public async load() {
        if (this.isNewPost()) {
            this.data = { title: '', content: '', category: '', status: 'draft' };
            this.tab = 'edit';
            await this.service.render();
            return;
        }

        this.data = null;
        await this.service.render();

        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href(this.basePath);
            return;
        }
        this.data = data;
        await this.loadComments();
        await this.service.render();
    }

    public async loadComments(){
        const res = await wiz.call('comments', { id: this.id });
        this.comments = res.code === 200 ? (res.data?.rows || []) : [];
        if (res.code !== 200) this.commentError = this.translate.instant('gap.comments.error');
    }
    public async addComment(){
        if(this.commentBusy || !this.commentText.trim())return;
        this.commentBusy=true;this.commentError='';
        await this.service.render();
        try {
            const res=await wiz.call('add_comment',{id:this.id,content:this.commentText});
            if(res.code!==200)throw new Error();
            this.commentText='';await this.loadComments();
        }catch(_){this.commentError=this.translate.instant('gap.comments.error');
        }finally{this.commentBusy=false;await this.service.render();}
    }
    public async deleteComment(comment:any){
        if(this.commentBusy)return;
        this.commentBusy=true;this.commentError='';
        try{
            const res=await wiz.call('delete_comment',{id:this.id,comment_id:comment.id});
            if(res.code!==200)throw new Error();
            await this.loadComments();
        }catch(_){this.commentError=this.translate.instant('gap.comments.error');
        }finally{this.commentBusy=false;await this.service.render();}
    }
    public async save() {
        if (!this.data.title) {
            await this.service.modal.error(this.translate.instant('portal.post.title_required'));
            return;
        }

        this.saving = true;
        await this.service.render();

        let payload = JSON.stringify(this.data);
        const { code, data } = await wiz.call("save", { data: payload });

        await this.service.sleep(800);
        this.saving = false;

        if (code === 200) {
            await this.service.modal.success(this.translate.instant('page.nodes.item.saved'));
            if (this.isNewPost() && data.id) {
                this.id = data.id;
                this.service.href(`${this.basePath}/${this.id}/view`);
            }
        } else {
            await this.service.modal.error(data || this.translate.instant('portal.post.save_failed'));
        }

        await this.service.render();
    }

    public async remove() {
        let res = await this.service.modal.show({
            title: this.translate.instant('portal.post.delete_title'),
            message: this.translate.instant('portal.post.delete_message'),
            action: this.translate.instant('common.delete'),
            actionBtn: "error",
            status: "error"
        });
        if (!res) return;

        const { code } = await wiz.call("delete", { id: this.id });
        if (code === 200) {
            this.service.href(this.basePath);
        }
    }

    public categoryLabel(category: string) {
        switch (category) {
            case '공지사항': return this.translate.instant('portal.post.category.notice');
            case '가이드': return this.translate.instant('portal.post.category.guide');
            case '기술 블로그': return this.translate.instant('portal.post.category.tech_blog');
            case '회의록': return this.translate.instant('portal.post.category.meeting_notes');
            case '자유게시판': return this.translate.instant('portal.post.category.free_board');
            default: return category;
        }
    }
}

export default PortalPostDetailComponent;
